const isElementFixed = (el) => {
  return window.getComputedStyle(el).getPropertyValue('position') === 'fixed';
};

const applyBannerOffset = (el, offset = null) => {
  const isFixed = isElementFixed(el);
  const offsetProperty = isFixed ? 'top' : 'marginTop';

  el.style[offsetProperty] = offset;
};

if (document.getElementById('skip-to-content')) {
  const skipToContent = document.getElementById('skip-to-content');
  const mainContent = document.getElementById('main-content');
  const header = document.getElementsByTagName('header')[0];

  skipToContent.addEventListener('click', function () {
    if (!mainContent) {
      return;
    }

    mainContent.focus();
  });

  skipToContent.addEventListener('focus', function () {
    const skipToContentBounds = skipToContent.getBoundingClientRect();

    if (!header) {
      return;
    }

    applyBannerOffset(header, skipToContentBounds.height + 'px');
  });

  skipToContent.addEventListener('blur', function () {
    if (!header) {
      return;
    }

    applyBannerOffset(header, null);
  });
}
